export function maxOf(values: Iterable<number>): number {
  let largest = -Infinity
  for (const value of values) largest = Math.max(largest, value)
  return largest
}

export function minOf(values: Iterable<number>): number {
  let smallest = Infinity
  for (const value of values) smallest = Math.min(smallest, value)
  return smallest
}
